import axios from "axios";
import { showError, showSuccess } from "../../../utils/toastUtils";

const DayToggleModal = ({ setDayToggleModal, dayToggleModal, fetchSlots }) => {
  const handleToggleClick = async () => {
    const { slot, day, isActive, branchId } = dayToggleModal;

    const updatedDays = isActive
      ? slot.activeDays.filter((d) => d !== day)
      : [...slot.activeDays, day];
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/slot-bookings/${slot._id}`,
        { activeDays: updatedDays, branchId },
      );

      showSuccess(
        `Slot ${isActive ? "disabled" : "enabled"} for ${dayToggleModal.label}`,
      );

      setDayToggleModal(null);
      fetchSlots();
    } catch {
      showError("Failed to update slot day");
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
      <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
        <h3 className="text-lg font-semibold text-primaryTextColor">
          {dayToggleModal.isActive ? "Disable" : "Enable"}{" "}
          {dayToggleModal.label}
        </h3>

        <p className="text-sm text-secondaryTextColor mt-2">
          This will {dayToggleModal.isActive ? "disable" : "enable"} bookings
          for this slot on <strong>{dayToggleModal.label}</strong>.
        </p>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={() => setDayToggleModal(null)}
            className="px-4 py-2 rounded-xl bg-gray-100 text-gray-700 font-semibold"
          >
            Cancel
          </button>

          <button
            onClick={handleToggleClick}
            className="px-4 py-2 rounded-xl bg-[#f0653a] text-white font-semibold"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};
export default DayToggleModal;
